import moment from 'moment';

import type { ScheduleListItemData } from '../../../typing/scheduleItem';

export interface ActiveDateSection {
  /** Stable key for collapse state, e.g. "date:2026-06-07" */
  key: string;
  /** Raw scheduled date "YYYY-MM-DD" */
  date: string;
  /** Display label, e.g. "Jun 7, 2026" */
  title: string;
  /** Number of completed schedules on this date */
  totalCompleted: number;
  /** Total number of schedules on this date */
  totalCount: number;
  data: ScheduleListItemData[];
}

/**
 * Groups a flat list of schedule items by their scheduledDate into sections,
 * each carrying a "Reports Completed: X/Y" summary. Sections are sorted by
 * date ascending. Mirrors audit-lite's active-period date grouping.
 */
export function groupActiveScheduleByDate(items: ScheduleListItemData[]): ActiveDateSection[] {
  const groupMap = new Map<string, ScheduleListItemData[]>();

  for (const item of items) {
    const date = item.scheduledDate;
    if (!groupMap.has(date)) {
      groupMap.set(date, []);
    }
    groupMap.get(date)!.push(item);
  }

  return Array.from(groupMap.entries())
    .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
    .map(([date, data]) => ({
      key: `date:${date}`,
      date,
      title: moment(date, 'YYYY-MM-DD').format('MMM D, YYYY'),
      totalCompleted: data.filter(item => item.status === 'completed').length,
      totalCount: data.length,
      data
    }));
}
